<template>
    <div
        ref="tile-swiper"
        :class="[
            'tile-swiper-container',
            theme,
            pageLang,
            {
                pc: isPc
            }
        ]"
        :style="[
            cssProperties,
            !isVertical ? { flexDirection: 'column-reverse' } : { flexDirection: 'row', alignItems: 'center' }
        ]"
    >
        <ul v-if="isVertical" class="card-list">
            <li
                v-for="(item, index) in list"
                :key="index"
                :class="[
                    'card-item',
                    textType,
                    activeType,
                    {
                        active: activeIndex === index
                    }
                ]"
                @click="handleActive(index)"
            >
                <img class="icon" :src="item.icon" alt="" />
                <div class="text">
                    <template v-if="isLimitText">
                        <p class="title text-over limit-1" v-html="item.title"></p>
                        <p class="desc text-over limit-2" v-html="item.desc"></p>
                    </template>
                    <template v-else>
                        <p class="title" v-html="item.title"></p>
                        <CollapseTransition v-if="activeIndex === index">
                            <p class="desc" v-html="item.desc"></p>
                        </CollapseTransition>
                    </template>
                </div>
            </li>
        </ul>
        <div v-else class="thumbs-list">
            <div class="swiper thumbs-swiper" ref="thumbs">
                <div class="swiper-wrapper">
                    <div
                        v-for="(item, index) in list"
                        :key="index"
                        :class="[
                            'swiper-slide',
                            textType,
                            activeType,
                            {
                                active: activeIndex === index
                            }
                        ]"
                        @click="handleActive(index)"
                    >
                        <img class="icon" :src="item.icon || item.img" :alt="item.alt || item.title || ''" />
                        <div class="text">
                            <p :class="['title', 'text-over', isLimitText ? 'limit-1' : '']" v-html="item.title"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="img-list" :class="{ 'is-auto-slides': isAutoSlides, horizontal: !isVertical }" ref="swiper">
            <div class="swiper-wrapper">
                <div v-for="(item, i) in list" :key="i" class="swiper-slide">
                    <flow-container
                        v-if="swiperType === SWIPER_TYPE.VIDEO"
                        :children="children[i] ? [children[i]] : []"
                    />
                    <img
                        v-else
                        @click="handleClickSwiperImg(item.jumpLink)"
                        class="swiper-item"
                        :src="item.img"
                        :alt="item.alt || ''"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CONSTANT from '../common/constants';
const { SWIPER_TYPE, TEXT_OVERFLOW, DIRECTION, SLIDES_PER_VIEW } = CONSTANT;
const {
    plugins: { ComplexComp }
} = require('@futuweb/fego-render') || require('@futuweb/fego-editor');
const {
    common: {
        behavior: { runBehaviour }
    }
} = require('@futuweb/fego-render');
import { isEditor, isPc, getPageLang, isScheme } from '../fego/utils';
import Swiper from 'swiper';
import { Autoplay, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/thumbs';
const {
    rem: { rem }
} = require('@futuweb/fego-bridge');
import CollapseTransition from './CollapseTransition/index.vue';
export default {
    name: 'tile-swiper',
    components: {
        FlowContainer: ComplexComp.Container.Flow,
        CollapseTransition
    },
    props: {
        tpl: Object,
        // 类型
        textType: String,
        activeType: Boolean,
        direction: {
            type: String,
            default: DIRECTION.VERTICAL
        },
        // css 变量
        titleColor: String,
        descColor: String,
        bgColor: String,
        borderColor: String,
        titleActiveColor: String,
        descActiveColor: String,
        bgActiveColor: String,
        borderActiveColor: String,
        list: {
            type: Array,
            default: () => []
        },
        // 图片
        swiperWidth: {
            type: Number,
            default: 250
        },
        swiperHeight: {
            type: Number,
            default: 340
        },
        // 轮播
        loop: Boolean,
        autoPlay: Boolean,
        autoPlayDelay: {
            type: Number,
            default: 3000
        },
        // 暂不开放
        layoutSpace: {
            type: Number,
            default: 25
        },
        cardSpace: {
            type: Number,
            default: 20
        },
        cardHPadding: {
            type: Number,
            default: 15
        },
        swiperType: {
            type: String,
            default: SWIPER_TYPE.IMG
        },
        textLimit: {
            type: Number,
            default: TEXT_OVERFLOW.DEFAULT
        },
        slidesPerView: {
            type: [Number, String],
            default: SLIDES_PER_VIEW.DEFAULT
        },
        centeredSlides: {
            type: Boolean,
            default: false
        },
        spaceBetween: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isPc: isPc(),
            isEditor: isEditor(),
            pageLang: getPageLang(),
            SWIPER_TYPE,
            isPreRender: window.FEGORender?.common.env.isPreRender,
            activeIndex: 0,
            thumbsSwiper: null
        };
    },
    computed: {
        cssProperties() {
            return {
                '--swiper-item-width': `${rem.str(this.swiperWidth)}`,
                '--swiper-item-height': `${rem.str(this.swiperHeight)}`,
                '--space-between': !this.isVertical ? 0 : `${rem.str(this.layoutSpace)}`,
                '--card-space': `${rem.str(this.cardSpace)}`,
                '--card-h-padding': `${rem.str(this.cardHPadding)}`,
                '--editor-help-border': this.isEditor ? '1px dashed #e5e5e5' : 'none',
                '--card-border-color': this.borderColor,
                '--card-bg-color': this.bgColor,
                '--card-title-color': this.titleColor,
                '--card-desc-color': this.descColor,
                '--card-border-active-color': this.borderActiveColor,
                '--card-bg-active-color': this.bgActiveColor,
                '--card-title-active-color': this.titleActiveColor,
                '--card-desc-active-color': this.descActiveColor
            };
        },
        swiperOptions() {
            return {
                loop: this.loop,
                autoPlay: this.autoPlay,
                autoPlayDelay: this.autoPlayDelay,
                allowTouchMove: true,
                direction: this.direction,
                spaceBetween: this.isVertical ? 0 : this.spaceBetween,
                slidesPerView: this.isVertical ? SLIDES_PER_VIEW.DEFAULT : this.slidesPerView,
                centeredSlides: this.isVertical ? false : this.centeredSlides
            };
        },
        children() {
            return (this.tpl.children || []).map((item) => {
                item.style.width = this.swiperWidth;
                item.style.height = this.swiperHeight;
                return item;
            });
        },
        isVertical() {
            return this.direction === DIRECTION.VERTICAL;
        },
        isLimitText() {
            return this.textLimit === TEXT_OVERFLOW.DEFAULT || !this.textLimit;
        },
        isAutoSlides() {
            return this.slidesPerView === SLIDES_PER_VIEW.AUTO;
        }
    },
    watch: {
        list: {
            deep: true,
            handler() {
                this.$nextTick(this.initSwiper);
            }
        },
        swiperOptions: {
            deep: true,
            handler() {
                this.$nextTick(this.initSwiper);
            }
        },
        activeIndex(index) {
            if (index !== this.swiper?.realIndex) {
                this.swiper?.[this.loop ? 'slideToLoop' : 'slideTo'](index);
            }
        }
    },
    methods: {
        handleActive(index) {
            this.activeIndex = index;
        },
        destroySwipers() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
            if (this.thumbsSwiper) {
                this.thumbsSwiper.destroy(true, true);
                this.thumbsSwiper = null;
            }
        },
        initSwiper() {
            const $swiper = this.$refs['swiper'];
            const needsThumbs = !this.isVertical;
            const $thumbs = needsThumbs ? this.$refs['thumbs'] : null;
            this.destroySwipers();
            if (!this.list.length || !$swiper) {
                return;
            }
            if (needsThumbs) {
                if (!$thumbs) {
                    return;
                }
                const thumbSpaceBetween = Number(this.cardSpace) || 0;
                this.thumbsSwiper = new Swiper($thumbs, {
                    modules: [Thumbs],
                    slidesPerView: SLIDES_PER_VIEW.AUTO,
                    centeredSlides: false,
                    watchSlidesProgress: true,
                    slideToClickedSlide: true,
                    spaceBetween: thumbSpaceBetween,
                    allowTouchMove: true
                });
            }
            const {
                loop,
                autoPlay,
                autoPlayDelay,
                allowTouchMove,
                direction,
                spaceBetween,
                slidesPerView,
                centeredSlides
            } = this.swiperOptions;
            const modules = [Autoplay];
            const swiperConfig = {
                modules,
                initialSlide: this.activeIndex,
                direction,
                loop,
                autoplay: autoPlay && {
                    // 每隔3秒自动播放
                    delay: autoPlayDelay || 3000,
                    // 被用户交互之后，会继续自动播放
                    disableOnInteraction: false
                },
                autoHeight: true,
                allowTouchMove,
                spaceBetween,
                slidesPerView,
                centeredSlides,
                on: {
                    slideChange: (swiper) => {
                        this.activeIndex = swiper.realIndex;
                        // iOS WKWebView 某些版本 Thumbs 不自动滚动，手动同步缩略图
                        const targetIndex = this.loop ? swiper.realIndex : swiper.activeIndex;
                        this.thumbsSwiper?.slideTo?.(targetIndex, 300, false);
                    }
                }
            };
            if (needsThumbs && this.thumbsSwiper) {
                modules.push(Thumbs);
                swiperConfig.thumbs = {
                    swiper: this.thumbsSwiper
                };
            }
            this.swiper = new Swiper($swiper, swiperConfig);
        },
        handleClickSwiperImg(jumpLink) {
            if (this.isEditor || !jumpLink) {
                return;
            }
            const isSchemeLink = isScheme(jumpLink);
            const type = isSchemeLink ? 'jump' : 'link';
            runBehaviour(this, {
                type,
                value: jumpLink,
                withQuery: !isSchemeLink
            });
        }
    },
    mounted() {
        !this.isPreRender && this.$nextTick(this.initSwiper);
    },
    beforeDestroy() {
        this.destroySwipers();
    },
    beforeUnmount() {
        this.destroySwipers();
    }
};
</script>
<style lang="less" scoped>
@import './variables.less';
.tile-swiper-container {
    height: auto !important;
    display: flex;
    > .img-list {
        margin-left: var(--space-between);
    }
}
.img-list {
    width: var(--swiper-item-width);
    height: var(--swiper-item-height);
    overflow: hidden;
    &.is-auto-slides {
        width: 100%;
        max-width: 100%;
    }
    &.horizontal {
        margin: 0 auto;
    }
    .swiper-slide {
        width: var(--swiper-item-width);
        height: var(--swiper-item-height);
        border: var(--editor-help-border);
        overflow: hidden;
    }
    .swiper-item {
        width: 100%;
        height: auto;
    }
}
.thumbs-list {
    user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    border: var(--editor-help-border);
    .thumbs-swiper {
        width: 100%;
        padding: 0.16rem 0;
        padding-top: 0.2rem;
    }
    .swiper-slide {
        flex-direction: column;
        align-items: flex-start;
        width: 1.65rem;
        margin-right: var(--card-space);
        cursor: pointer;
        background-color: var(--card-bg-color);
        border-radius: 0.2rem;
        &.only-icon {
            .icon {
                display: block;
            }
        }
        &.text {
            .text {
                display: block;
            }
        }
        &.with-icon {
            .icon {
                display: block;
            }
        }
        .icon {
            display: none;
            margin: 0.1rem 0.1rem;
            width: 1.4rem;
            height: 1.4rem;
            border-radius: 0.2rem;
        }
        .text {
            display: none;
            margin-top: 0.16rem;
            width: 100%;
            word-break: break-word;
            padding: 0 0.15rem;
            font-size: 0.24rem;
            .title {
                margin-bottom: 0.06rem;
                color: var(--card-title-color);
            }
        }
        &.text-active {
            &.active {
                .title {
                    color: var(--card-title-active-color);
                }
            }
        }
        &.border-active {
            border: 0.01rem solid var(--card-border-color);
            &.active {
                border-color: var(--card-border-active-color);
                background-color: var(--card-bg-active-color);
            }
        }
    }
    .card-item:last-child {
        margin-right: 0;
    }
    .card-item + .card-item {
        margin-top: 0;
    }
}
.card-list {
    flex: 1;
    border: var(--editor-help-border);
    .card-item {
        display: flex;
        align-items: center;
        cursor: pointer;
        background-color: var(--card-bg-color);
        border-radius: 0.1rem;
        + .card-item {
            margin-top: var(--card-space);
        }
        &.with-icon {
            .icon {
                display: block;
            }
        }
        &.only-icon {
            .icon {
                display: block;
            }
        }
        &.text {
            .text {
                display: block;
            }
        }
        .icon {
            display: none;
            margin-right: 0.2rem;
            width: 0.8rem;
            height: 0.8rem;
            border-radius: 0.1rem;
        }
        .text {
            display: none;
            flex: 1;
            .title {
                font-weight: var(--card-title-font-weight);
                font-size: var(--card-title-font-size);
                line-height: var(--card-title-line-height);
                color: var(--card-title-color);
            }
            .desc {
                font-size: var(--card-desc-font-size);
                line-height: var(--card-desc-line-height);
                color: var(--card-desc-color);
                margin-top: 0.14rem;
            }
        }
        &.text-active {
            padding: 0.24rem var(--card-h-padding);
            &.active {
                .title {
                    color: var(--card-title-active-color);
                }
                .desc {
                    color: var(--card-desc-active-color);
                }
            }
        }
        &.border-active {
            padding: 0.24rem var(--card-h-padding);
            border: 0.01rem solid var(--card-border-color);
            &.active {
                border-color: var(--card-border-active-color);
                background-color: var(--card-bg-active-color);
                .icon {
                    border-color: var(--card-border-active-color);
                }
            }
        }
    }
}
.text-over {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: center;
    &.limit-1 {
        line-clamp: 1;
        -webkit-line-clamp: 1;
    }
    &.limit-2 {
        line-clamp: 2;
        -webkit-line-clamp: 2;
    }
}
</style>
